import moment from 'moment';

// Keep in sync with ADMIN_DELETE_WINDOW_DAYS in
// be/src/controllers/SickLeaveController.ts -- the back end is authoritative,
// this only decides whether the remove button is offered.
export const ADMIN_DELETE_WINDOW_DAYS = 7;

// Earliest sick leave date the current viewer may still remove. Regular users
// get today and anything later; admins also get the preceding week.
export const getEarliestDeletableDate = (isAdmin: boolean) => moment()
  .subtract(isAdmin ? ADMIN_DELETE_WINDOW_DAYS : 0, 'days')
  .format('YYYY-MM-DD');
